var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenTickFillIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#07B055"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87191 4.01158C8.25256 4.15555 6.72722 4.875 5.55438 6.04796C2.80349 8.79921 2.80349 13.1852 5.55438 15.9365C8.30527 18.6877 12.6907 18.6877 15.4416 15.9365C16.6319 14.746 17.3344 13.2405 17.4801 11.5673C17.5248 11.0543 17.5178 10.9129 17.44 10.758C17.3558 10.5901 17.2218 10.4953 17.0449 10.4783C16.8082 10.4556 16.5833 10.5764 16.5025 10.7698C16.4786 10.827 16.4531 11.0345 16.4384 11.2914C16.3889 12.16 16.2167 12.8243 15.8381 13.6076C15.1022 15.1304 13.6152 16.3454 11.9849 16.7561C11.4027 16.9027 11.2407 16.9207 10.498 16.9207C9.75531 16.9207 9.59331 16.9027 9.01107 16.7561C6.96797 16.2414 5.24947 14.5227 4.73489 12.4793C4.58825 11.897 4.57032 11.735 4.57032 10.9922C4.57032 10.2494 4.58825 10.0874 4.73489 9.5051C5.1455 7.87462 6.36037 6.38742 7.88292 5.65138C8.66618 5.27273 9.33033 5.10055 10.1989 5.05101C10.4557 5.03633 10.6632 5.01086 10.7204 4.98696C10.9137 4.90616 11.0346 4.68121 11.0119 4.44448C10.9949 4.26751 10.9 4.13351 10.7322 4.04927C10.5827 3.9742 10.3882 3.96568 9.87191 4.01158Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83594 10.4593L10.131 12.7544L15.8688 7.0166",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickFillIcon);
export default __webpack_public_path__ + "static/media/greenTickFillIcon.1ebd525c51a7c53680764a1798001bec.svg";
export { ForwardRef as ReactComponent };